import Navbar from "@/components/Main/Navbar/Navbar.vue";
import AdMenu from "@/components/Main/AdMenu/AdMenu.vue";
import SideMenu from "@/components/Main/SideMenu/SideMenu.vue";
import Feed from "@/components/Main/Feed/Feed.vue";
import NewTopic from "@/components/Main/NewTopic/NewTopic.vue";
import EditTopic from "@/components/Main/EditTopic/EditTopic.vue";
import Map from "@/components/Map/Map.vue";
import CircleSettings from "@/components/Main/CircleSettings/CircleSettings.vue";
import CircleCampaignList from "@/components/Main/CircleCampaignList/CircleCampaignList.vue";
import CircleMemberList from "@/components/Main/CircleMemberList/CircleMemberList.vue";
import CircleAudience from "@/components/Main/CircleAudience/CircleAudience.vue";
import JoinCircle from "@/components/Main/JoinCircle/JoinCircle.vue";
import SendPostSMS from "@/components/Main/SendPostSMS/SendPostSMS.vue";
import SendPostEmail from "@/components/Main/SendPostEmail/SendPostEmail.vue";
import { mapState, mapActions } from "vuex";
import DataHandlerService from "@/services/data";
import CircleService from "@/services/circle";
import ContentService from "@/services/content";
import InMemoryDb from "@/services/inmemorydb";
import GeometryUtils from "@/utils/geometry";
import * as constants from "@/constants/index";
import AddCircle from "@/components/Main/AddCircle/AddCircle.vue";
import router from "@/router";
import happroxy from "@/filters/happroxy";
import swal from 'sweetalert';

const data = new DataHandlerService();
const InMemoryDatabase = new InMemoryDb();
const circleService = new CircleService();
const contentService = new ContentService();
const geometryUtils = new GeometryUtils();
const LIMIT = constants.LIMIT;

export default {
  name: "ACircle",
  components: {
    Navbar,
    AdMenu,
    SideMenu,
    Feed,
    NewTopic,
    EditTopic,
    CircleSettings,
    JoinCircle,
    Map,
    AddCircle,
    CircleCampaignList,
    CircleMemberList,
    CircleAudience,
    SendPostSMS,
    SendPostEmail,
  },
  data() {
    return {
      circle_id: "",
      STATES: ["FEED", "NEW_POST", "TOPICS", "SETTINGS", "CAMPAIGNS", "MEMBERS", "AUDIENCE", "EDIT_POST"],
      state: "FEED",
      user: null,
      circle: null,
      isUserAdmin: false,
      canUserCreateContent: false,
      contentLoading: true,
      topicPage: 0,
      postPage: 0,
      tempTopics: null,
      topics: null,
      tempPosts: null,
      posts: null,
      isUserMember: false,
      circleChildren: null,
      isChildCircle: false,
      coordinates: { lat: 9.0748812, lng: 7.465183},
      markers: null,
      infoWindows: null,
      campaigns: null,
      selectedPost: null,
      selectedTopic: null,
      circleIdentities: null,
      audience: [],
    };
  },
  created() {
    circleService.delete();

    this.user = data.getUserData();

    this.getCircleAudience();
    
    this.$root.$on("fetchMoreContent_Circle", () => this.loadCircleContentSubsequent());
    
    this.$root.$on("NewPostAdded", post => {
      if (post.circle_id === this.circle_id) {
        post.type = "media";
        this.tempPosts = this.sort([post, ...this.tempPosts]);
        this.posts = [...this.tempPosts]
        this.circle.media_count += 1;
        this.circle.upload_count += post.media_uploads.length;
        this.isChildCircle ? InMemoryDatabase.addChildCircle(this.circle) : InMemoryDatabase.addCircle(this.circle);
      }
    });
    this.$root.$on("SaveNewTopic", msg => {
      // this.fetchTopicsFromAPISinglePage(0).then(res => {}).catch(e => {})
    });
    this.$root.$on("NewTopicAdded", topic => {
      if (topic.circle_id === this.circle_id) {
        topic.type = "topic";
        this.tempTopics = this.sort([topic, ...this.tempTopics]);
        this.topics = [...this.tempTopics];
        this.circle.topic_count += 1;
        this.isChildCircle ? InMemoryDatabase.addChildCircle(this.circle) : InMemoryDatabase.addCircle(this.circle);
      }
    });
    this.$root.$on("CircleModified", circle => {
      if (circle._id === this.circle_id) {
        circle.visible = circle.flags ? circle.flags.find(flag => flag.type.toLowerCase() === "visibility").value.toLowerCase() === "public" : false;
      
        this.circle = circle;
      }
    })
    this.$root.$on("PostModified", post => {
      if (post.circle_id === this.circle_id) {
        const postIndex = this.tempPosts.findIndex(s => s._id === post._id);

        if (postIndex > -1) {
          this.tempPosts.splice(postIndex, 1, post);
          this.posts = [...this.tempPosts];
        }
      }
    });
    this.$root.$on("CircleDeleted", _id => {
      if (_id === this.circle_id) {
        router.replace({ path: '/feed'});
      }
    });
    this.$root.$on("AddNewMemberToCircle", obj => {
      if (this.circle_id === obj.circle_id) {
        const circle = { ...this.circle };

        circle.boards.push(obj.board);

        circle.boards = Array.from(new Set(circle.boards.map(s => s._id))).map(_id => circle.boards.find(s => s._id === _id));

        circle.member_count = circle.boards.length;
        InMemoryDatabase.addCircle(circle);
        this.circle = circle;
      }
    });
    this.$root.$on("stateChangeFromEmptyFeed", emittedState => this.state = emittedState);
    this.$root.$on("sendPostAsSMS", post => {
      this.selectedPost = post;
      document.getElementById("sendSMSBtn").click();
    })
    this.$root.$on("sendPostAsEmail", post => {
      this.selectedPost = post;
      document.getElementById("sendEmailBtn").click();
    })
    this.$root.$on("CreateAudience", audience => {
      this.audience.unshift(audience);
      this.getCircleAudience();
    })
    this.$root.$on("DeleteAudience", audience => {
      this.audience = this.audience.filter(item => item._id !== audience);
      this.getCircleAudience();
    })
    this.$root.$on("UpdateAudience", audience => {
      this.audience = this.audience.map(item => {
        if(item._id === audience._id) {
          item = {
            ...item,
            ...audience
          }
        }
        return item
      });
      this.getCircleAudience();
    })
    this.$root.$on("openTopicEditor", topic => {
      this.selectedTopic = topic
      this.state = this.STATES[7]
    })
  },
  computed: {
    ...mapState(["circles"]),
    members: function() {
      if (this.circle) {
        return this.circle.boards || this.circle.board || [];
      }
      return;
    },
    identities: function() {
      if (this.circle) {
        return this.circle.identities;
      }
      return;
    },
    smsAudience: function() {
      return this.audience.filter(item => item.type === 'sms')
    },
    emailAudience: function() {
      return this.audience.filter(item => item.type === 'email')
    }
  },
  methods: {
    ...mapActions(["removeCircle", "updateCircle"]),
    reactToStateChange(emittedState) {
      this.state = emittedState;
    },
    async loadCircleInfo() {
      let circle;

      if (this.isChildCircle) {
        circle = await InMemoryDatabase.getChildCircle(this.circle_id);
        if (circle && Object.keys(circle).length) {
          this.circle = circle;
        }
      } else {
        if (this.circles) {
          circle = this.circles.find(circle => circle._id === this.circle_id);
          if (circle) {
            this.circle = circle;
          } else {
            circle = await InMemoryDatabase.getCircle(this.circle_id);
            if (circle && Object.keys(circle).length) {
              this.circle = circle;
            }
          }
        } else {
          circle = await InMemoryDatabase.getCircle(this.circle_id);
          if (circle && Object.keys(circle).length) {
            this.circle = circle;
          }
        }
      }

      circleService.readCircle(this.circle_id).then(circle => {
        if (circle) {
          this.circle = circle;

          if (this.isChildCircle) {
            InMemoryDatabase.addChildCircle(circle);
          } else {
            this.updateCircle(circle);
            InMemoryDatabase.addCircle(circle);
          }
        } else {
          router.replace({ path: "/404" });
        }
      }).catch((err) => this.$root.$emit("ShowErrorNotification", err.message));
    },
    async fetchTopicsFromAPISinglePage(page) {
      let topics;

      const fetchTopicsFromAPI = [contentService.readCircleTopics(this.circle_id, LIMIT, page)];

      await Promise.all(fetchTopicsFromAPI).then(res => {
        res = res[0];
        let response = res.content;
        topics = this.tempTopics || [];
        response.map(item => {
          if (!topics.find(topic => topic._id === item._id)) {
            topics.push(item);
          }
          InMemoryDatabase.addTopic(item);
        });

        if (this.topicPage > res.max) {
          (res.content.length < LIMIT) ? (this.topicPage = (res.max - 1)) : (this.topicPage = res.max);
        }
      }).catch((err) => {
        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
        return null;
      });
      return topics;
    },
    async fetchTopicsFromAPIMultiPage(max_page) {
      let fetchRequests = [], topics;
      for (let i = 1; i <= max_page; i++) {
        fetchRequests = [...fetchRequests, contentService.readCircleTopics(this.circle_id, LIMIT, i)];

        if (i === max_page) {
          await Promise.all(fetchRequests).then(res => {
            let response = [];
            res.map(s => response = [...response, ...s.content]);
            topics = this.tempTopics || [];

            response.map(item => {
              if (!topics.find(topic => topic._id === item._id)) {
                topics.push(item);
              }
              InMemoryDatabase.addTopic(item);
            });
          }).catch((err) => {
            (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
            (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
            return null;
          });

          return topics;
        }
      }
    },
    async fetchPostsFromAPISinglePage(page) {
      let posts;
      const fetchPostsFromAPI = [contentService.readCirclePosts(this.circle_id, LIMIT, page)];

      await Promise.all(fetchPostsFromAPI).then(res => {
        res = res[0];
        let response = res.content;
        posts = this.tempPosts || [];
        response.map(item => {
          if (!posts.find(post => post._id === item._id)) {
            posts.push(item);
          }
          InMemoryDatabase.addPost(item);
        });

        if (this.postPage > res.max) {
          (res.content.length < LIMIT) ? (this.postPage = (res.max - 1)) : (this.postPage = res.max);
        }
      }).catch((err) => {
        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
        return null;
      });
      return posts;
    },
    async fetchPostsFromAPIMultiPage(max_page) {
      let fetchRequests = [], posts = null;
      for (let i = 1; i <= max_page; i++) {
        fetchRequests = [...fetchRequests, contentService.readCirclePosts(this.circle_id, LIMIT, i)];

        if (i === max_page) {
          await Promise.all(fetchRequests).then(res => {
            let response = [];
            res.map(s => response = [...response, ...s.content]);
            posts = this.tempPosts || [];

            response.map(item => {
              if (!posts.find(post => post._id === item._id)) {
                posts.push(item);
              }
              InMemoryDatabase.addPost(item);
            });
          }).catch((err) => {
            (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
            (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
            return null;
          });
          return posts;
        }
      }
    },
    sort(arr) {
      return arr.sort((a, b) => {
        const [A, B] = [a.created, b.created];

        if (A < B) {
          return 1;
        }

        if (A > B) {
          return -1;
        }

        return 0;
      });
    },
    async loadCircleContentSubsequent() {
      this.contentLoading = true;

      if(this.state === this.STATES[0]) {
        try {
          let posts = await InMemoryDatabase.getCirclePosts(this.circle_id);
          
          if (posts.length) {
            this.tempPosts = this.sort(posts);
            this.posts = [...this.tempPosts];
            this.postPage = Math.round(posts.length/LIMIT);
          }

          posts = await this.fetchPostsFromAPISinglePage(++this.postPage);

          if (posts) {
            this.tempPosts = this.sort(posts);
            this.posts = [...this.tempPosts];
          }

          this.contentLoading = false;
        } catch(e) {
          this.contentLoading = false;
        }
      }

      if(this.state === this.STATES[2]) {
        try {
          let topics = await InMemoryDatabase.getCircleTopics(this.circle_id);

          if (topics.length) {
            this.tempTopics = this.sort(topics);
            this.topics = [...this.tempTopics];
            this.topicPage = Math.round(temp.length/LIMIT);
          }

          topics = await this.fetchTopicsFromAPISinglePage(++this.topicPage);
          
          if (topics) {
            this.tempTopics = this.sort(topics);
            this.topics = [...this.tempTopics];
          }

          this.contentLoading = false;
        } catch(e) {
          this.contentLoading = false;
        }
      }

      if (this.state === this.STATES[4]) {
        this.loadCampaigns();
      }
    },
    async loadCircleContent(val) {
      if(this.state === this.STATES[0]) {
        let posts = await InMemoryDatabase.getCirclePosts(val._id);

        if (posts.length) {
          this.tempPosts = this.sort(posts);
          this.posts = [...this.tempPosts];
          this.postPage = Math.round(posts.length/LIMIT);

          if (this.postPage > 1) {
            posts = await this.fetchPostsFromAPIMultiPage(this.postPage);

            if (posts) {
              this.tempPosts = this.sort(posts);
              this.posts = [...this.tempPosts];
            }

            this.contentLoading = false;
          } else {
            this.postPage = 1;
            posts = await this.fetchPostsFromAPISinglePage(this.postPage);

            if (posts) {
              this.tempPosts = this.sort(posts);
              this.posts = [...this.tempPosts];
            }

            this.contentLoading = false;
          }
        } else {
          posts = await this.fetchPostsFromAPISinglePage(++this.postPage);

          if (posts) {
            this.tempPosts = this.sort(posts);
            this.posts = [...this.tempPosts];
          }

          this.contentLoading = false;
        }
      }
      
      if (this.state === this.STATES[2]) {
        let topics = await InMemoryDatabase.getCircleTopics(val._id);
        if (topics.length) {
          this.tempTopics = this.sort(topics);
          this.topics = [...this.tempTopics];
          this.topicPage = Math.round(topics.length/LIMIT);

          if (this.topicPage > 1) {
            topics = await this.fetchTopicsFromAPIMultiPage(this.topicPage);

            if (topics) {
              this.tempTopics = this.sort(topics);
              this.topics = [...this.tempTopics];
            }

            this.contentLoading = false;
          } else {
            this.topicPage = 1;

            topics = await this.fetchTopicsFromAPISinglePage(this.topicPage);

            if (topics) {
              this.tempTopics = this.sort(topics);
              this.topics = [...this.tempTopics];
            }

            this.contentLoading = false;
          }
        } else {
          topics = await this.fetchTopicsFromAPISinglePage(++this.topicPage);

          if (topics) {
            this.tempTopics = this.sort(topics);
            this.topics = [...this.tempTopics];
          }

          this.contentLoading = false;
        }
      }

      if (this.state === this.STATES[4]) {
        this.loadCampaigns();
      }
    },
    scrollToContent(id) {
      document.getElementById(id).focus();
    },
    spawnNewCircle() {
      document.getElementById("newCircleBtn").click();
    },
    resetCircleState() {
      this.isUserAdmin = false,
      this.canUserCreateContent = false,
      this.contentLoading = true,
      this.topicPage = 0,
      this.postPage = 0,
      this.tempTopics = null,
      this.topics = null,
      this.tempPosts = null,
      this.posts = null,
      this.isUserMember = false,
      this.circleChildren = null,
      this.isChildCircle = false,
      this.coordinates = { lat: 9.0748812, lng: 7.465183},
      this.markers = null,
      this.infoWindows = null,
      this.circleIdentities = null
    },
    async loadCampaigns() {
      this.contentLoading = true;

      try {
        let campaigns = await InMemoryDatabase.getCircleCampaigns(this.circle_id);

        if (campaigns.length) {
          this.campaigns = campaigns;
        }

        campaigns = await contentService.readCircleCampaigns(this.circle_id);

        if (campaigns) {
          campaigns.map(campaign => {
            campaign.assets.circle.filter(s => s.identifier === this.circle_id).map(circle => {
              circle.is_admin = (this.circle.boards || this.circle.board).find(b => b.profile_id === campaign.profile_id && b.type === 'role' && b.status !== 'default');
            });
            InMemoryDatabase.addCircleCampaign(campaign);
          });
        } else {
          this.campaigns = [];
        }

        this.contentLoading = false;
      } catch(e) {
        this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again.");
      }
    },
    leaveCircle(e) {
      const submitBtn = e.srcElement;
      const member = this.members.find(s => s.profile_id === this.user._id);

      swal({
        text: `Are you sure you want to leave this circle?`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((willLeave) => {
        if (willLeave) {
          const defaultBtnText = submitBtn.innerText;
          
          submitBtn.classList.add("btn--loading");
          submitBtn.disabled = true;
          submitBtn.innerText = 'Processing';

          circleService.removeMember(member, this.identities).then(() => {
            this.$notification.new(`You have been removed from the ${this.circle.title} circle`);
            this.$root.$emit("RemoveMemberFromCircle", member);
            this.$root.$emit("LeftCircle");
            e.preventDefault();
          }).catch(err => {
            submitBtn.classList.remove("btn--loading");
            submitBtn.disabled = false;
            submitBtn.innerText = defaultBtnText;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      });
    },
    getCircleIdentities (circle_id) {
      circleService.getCircleIdentities(circle_id)
        .then(res => {
          this.circleIdentities = res;
        })
        .catch(err => {
          this.$root.$emit("ShowErrorNotification", err.message);
        })
    },
    getCircleAudience () {
      // const form = new FormData;
      // form.append()
      contentService.readCircleAudience(this.circle_id)
        .then(res => {
          this.audience = res.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  watch: {
    circle: {
      handler: async function(val) {
        if (val) {
          const board = val.board || val.boards || [];
          if (board.find(s => s.profile_id === this.user._id && s.type === "role" && s.status !== "default")) {
            this.canUserCreateContent = true;
            if (board.find(s => s.profile_id === this.user._id && s.type === "role" && (s.status === "administrator" || s.status === "owner"))) {
              this.isUserAdmin = true;
            } else {
              this.isUserAdmin = false;
              if (this.state === this.STATES[3]) {
                this.state = this.STATES[0];
              }
            }
          } else {
            this.isUserAdmin = false;
            this.canUserCreateContent = false;

            if (this.state === this.STATES[3] || this.state === this.STATES[1]) {
              this.state = this.STATES[0];
            }
          }

          if (board.find(s => s.profile_id === this.user._id)) {
            this.isUserMember = true;
          } else {
            this.isUserMember = false;
            this.removeCircle(val._id);
            InMemoryDatabase.removeCircle(val._id);
            if (!val.visible) {
              if (this.isChildCircle) {
                router.back();
              } else {
                router.replace({ path: "/feed" });
              }
              this.$root.$emit("ShowErrorNotification", "You are not a member of this private circle.");
            }
          }

          this.loadCircleContent(val);

          if (!this.isChildCircle) {
            try {
              this.circleChildren = await InMemoryDatabase.getCircleChildren(val._id);
            } catch (e) { }

            circleService.readCircleChildren(val).then((children) => {
              this.circleChildren = children;
              children.map(child => InMemoryDatabase.addChildCircle(child));
            }).catch(() => {})
          }

          if (val.locations && val.locations.length) {
            this.markers = val.locations.map(location => {
              return {
                position: { lat: location.latitude, lng: location.longitude },
                info: {
                  content: `<div>
                    <h6 style='margin: 7px auto 3px auto;font-size: 14px;'> ${location.title}</h6>
                  </div>`,
                  open: false,
                  canClose: true
                }
              }
            });

            let allPoints;

            if (this.infoWindows) {
              allPoints = [...val.locations.map(location => [location.latitude, location.longitude]),
                ...this.infoWindows.map(iw => [iw.position.lat, iw.position.lng])];
            } else {
              allPoints = val.locations.map(location => [location.latitude, location.longitude]);
            }

            const centerOfPoints = geometryUtils.getCenterOfPoints(allPoints) || this.coordinates;
            this.coordinates = centerOfPoints;
          }
        }
      },
      immediate: true,
      deep: true
    },
    "$route.params.id": {
      handler: async function(val) {
        if (val) {
          this.circle_id = val;
          this.getCircleIdentities(val);

          if (this.$route.params.parent_id) {
            this.resetCircleState();
            this.isChildCircle = true;
          } else {
            if (this.isChildCircle) {
              this.resetCircleState();
              this.circle = this.circles.find(s => s._id === val);
              this.isChildCircle = false;
            }
          }

          this.loadCircleInfo();
        }
      },
      immediate: true,
      deep: true
    },
    state: {
      handler: function() {
        this.loadCircleContentSubsequent();
      }
    },
    posts: {
      handler: function(val) {
        if (val) {
          const postsWithMapFlag = val.filter(s => s.media_flags.find(f => f.type === "location"));
          this.infoWindows = postsWithMapFlag.map(p => {
            return {
              options: {
                content: `<div>
                  <a href="javascript:void(0)" @click.prevent="null" id="${p._id}">
                    <h6 style='margin: 7px auto 3px auto;font-size: 14px;'>${p.topic.title}</h6>
                  </a>
                  <span role="time" style="text-decoration: none !important;">${happroxy(p.created)}</span>
                </div>`
              },
              text: p.topic.title,
              position: JSON.parse(p.media_flags.find(f => f.type === "location").value),
              open: true,
              canClose: false
            }
          });
          setTimeout(() => {
            postsWithMapFlag.map(s => {
              const postLink = document.getElementById(s._id);
              const post = document.getElementById(`${s._id}_content`);
              const scrollTo = function() {
                this.state = this.STATES[0];
                setTimeout(() => window.scrollTo(0, post.offsetTop), 500);
              }
              postLink.addEventListener("click", scrollTo.bind(this));
            });

            const allPoints = [...(this.circle.locations || []).map(location => [location.latitude, location.longitude]),
                ...this.infoWindows.map(iw => [iw.position.lat, iw.position.lng])];

            const centerOfPoints = geometryUtils.getCenterOfPoints(allPoints) || this.coordinates;
            this.coordinates = centerOfPoints;
          }, 1000);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
